import React from "react";
import styles from "./FormProgressCircle.module.scss";

type Props = {
    numberOfSteps: number;
    activeStep: number;
};

const FormProgressCircle: React.FC<Props> = (props: Props) => {
    const { activeStep, numberOfSteps } = props;

	return (
		<div className={styles.progressContainer}>
            {
                Array.from({ length: numberOfSteps }).map((_, index) => (
                    <div key={index} className={`${styles.progress} ${(activeStep - 1) === index ? styles.active : ""}`} />
                ))
            }
		</div>
	);
};

export default FormProgressCircle;
